import { EnvConfigService } from '@core/services/env-config.service';
import _package from 'package.json';
import { environment } from '@shared/environments/environment';

export function INIT_ENV_DATA(envConfigService: EnvConfigService) {
  return async () => {
    await envConfigService.init('./resources/env-config.json?v=' + _package.version);

    const shouldEnableMocks =
      Boolean(envConfigService.envConfig?.isMock) && !environment.production;

    if (shouldEnableMocks) {
      const mockServer = (await import('@mocks/index')).default;
      await mockServer(envConfigService.envConfig);
      return;
    }

    await unregisterMockServiceWorker();
  };
}

async function unregisterMockServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  for (const registration of registrations) {
    if (registration.active?.scriptURL.includes('mockServiceWorker')) {
      await registration.unregister();
      console.info('[MSW] Mock service worker unregistered');
    }
  }
}
